import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

const LogoSlideshow = (blockElem) => {

	const swiperEl = blockElem.querySelector('.swiper');
	if(!swiperEl) {
		return;
	}

	new Swiper(swiperEl, {
		modules: [Navigation, Pagination, Autoplay, EffectFade],
		loop: true,
		autoplay: {
			delay: 2500,
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: false
		},
		pagination: {
			el: swiperEl.querySelector('.swiper-pagination'),
		},
		navigation: {
			nextEl: swiperEl.querySelector('.swiper-button-next'),
			prevEl: swiperEl.querySelector('.swiper-button-prev'),
		},
	});
};

export default LogoSlideshow;